import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=d9c54cb2&scoped=true&"
import script from "./Opening.vue?vue&type=script&lang=js&"
export * from "./Opening.vue?vue&type=script&lang=js&"
import style0 from "./Opening.vue?vue&type=style&index=0&id=d9c54cb2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c54cb2",
  null
  
)

export default component.exports